import { Discussion, DiscussionsFetchArgs, getDiscussions } from '../assets/ts/data/discussions'
import useServerData from './use-server-data'

function useDiscussions(fetchArgs: DiscussionsFetchArgs) {
  const {
    data: DiscussionsData,
    error: DiscussionsDataError,
    fetchData: fetchDiscussionsData,
    isLoading: DiscussionsDataIsLoading,
  } = useServerData<Discussion, DiscussionsFetchArgs>(getDiscussions, fetchArgs)

  return {
    DiscussionsData,
    DiscussionsDataError,
    DiscussionsDataIsLoading,
    fetchDiscussionsData,
  }
}

export default useDiscussions
